"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _TabContent = _interopRequireDefault(require("./TabContent"));

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tabs =
/*#__PURE__*/
function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      pointer: {}
    });

    _defineProperty(_assertThisInitialized(_this), "navigationNode", void 0);

    _defineProperty(_assertThisInitialized(_this), "resizeTimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "updatePointerAnimationFrame", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleHeaderClick", function (idx) {
      if (_this.props.onChange) {
        _this.props.onChange(idx);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      var index = _this.props.index;

      if (_this.resizeTimeout) {
        window.clearTimeout(_this.resizeTimeout);
      }

      _this.resizeTimeout = window.setTimeout(function () {
        // Type assertion is needed here due to defaults not being typed
        _this.updatePointer(index);
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "updatePointer", function (idx) {
      _this.updatePointerAnimationFrame = requestAnimationFrame(function () {
        if (!_this.navigationNode || !_this.navigationNode.children[idx]) {
          return;
        }

        var nav = _this.navigationNode.getBoundingClientRect();

        var label = _this.navigationNode.children[idx].getBoundingClientRect();

        var scrollLeft = _this.navigationNode.scrollLeft;

        _this.setState({
          pointer: {
            top: "".concat(nav.height, "px"),
            left: "".concat(label.left + scrollLeft - nav.left, "px"),
            width: "".concat(label.width, "px")
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "scrollNavigation", function (factor) {
      if (_this.navigationNode) {
        var oldScrollLeft = _this.navigationNode.scrollLeft;
        _this.navigationNode.scrollLeft += factor * _this.navigationNode.clientWidth;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "scrollRight", function () {
      return _this.scrollNavigation(-1);
    });

    _defineProperty(_assertThisInitialized(_this), "scrollLeft", function () {
      return _this.scrollNavigation(+1);
    });

    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          index = _this$props.index,
          children = _this$props.children;
      var prevIndex = prevProps.index,
          prevChildren = prevProps.children;

      if (index !== prevIndex || children !== prevChildren) {
        // Type assertion is needed here due to defaults not being typed
        this.updatePointer(index);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.resizeTimeout);

      if (this.updatePointerAnimationFrame) {
        cancelAnimationFrame(this.updatePointerAnimationFrame);
      }
    }
  }, {
    key: "parseChildren",
    value: function parseChildren() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          theme = _this$props2.theme,
          disableTextAnimation = _this$props2.disableTextAnimation;
      var headers = [];
      var contents = [];

      _react["default"].Children.forEach(children, function (item) {
        if (!disableTextAnimation) {
          var label = item.props.label.props ? _objectSpread({}, item.props.label, {
            props: _objectSpread({}, item.props.label.props, {
              className: (0, _classnames3["default"])(theme.animatedText, item.props.label.props.className)
            })
          }) : _react["default"].createElement("span", {
            className: theme.animatedText
          }, item.props.label);
          headers.push(_react["default"].cloneElement(item, _objectSpread({}, item.props, {
            label: label
          })));
        } else {
          headers.push(item);
        }

        if (item.props.children) {
          // TODO: Should this still have theme={theme} here??
          contents.push(_react["default"].createElement(_TabContent["default"], {
            theme: {
              active: 'derp',
              tab: 'derp'
            }
          }, item.props.children));
        }
      });

      return {
        headers: headers,
        contents: contents
      };
    }
  }, {
    key: "renderHeaders",
    value: function renderHeaders(headers) {
      var _this2 = this;

      var _this$props3 = this.props,
          index = _this$props3.index,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme;
      return headers.map(function (item, idx) {
        return _react["default"].cloneElement(item, {
          children: null,
          key: idx,
          index: idx,
          theme: theme,
          active: index === idx,
          onClick: function onClick(event, index) {
            _this2.handleHeaderClick(index);

            if (item.props.onClick) {
              item.props.onClick(event);
            }
          }
        });
      });
    }
  }, {
    key: "renderContents",
    value: function renderContents(contents) {
      var _this$props4 = this.props,
          hideMode = _this$props4.hideMode,
          index = _this$props4.index,
          theme = _this$props4.theme;
      var contentElements = contents.map(function (item, idx) {
        return _react["default"].cloneElement(item, {
          key: idx,
          theme: theme,
          active: index === idx,
          hidden: index !== idx && hideMode === 'display',
          tabIndex: idx
        });
      });
      return hideMode === 'display' ? contentElements : contentElements.filter(function (item, idx) {
        return idx === index;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2,
          _this3 = this;

      var _this$parseChildren = this.parseChildren(),
          headers = _this$parseChildren.headers,
          contents = _this$parseChildren.contents;

      var _this$props5 = this.props,
          className = _this$props5.className,
          disableAnimatedBottomBorder = _this$props5.disableAnimatedBottomBorder,
          theme = _this$props5.theme,
          fixed = _this$props5.fixed,
          inverse = _this$props5.inverse;
      var classNamePointer = (0, _classnames3["default"])(theme.pointer, _defineProperty({}, theme.disableAnimation, disableAnimatedBottomBorder));
      var classNames = (0, _classnames3["default"])(theme.tabs, (_classnames2 = {}, _defineProperty(_classnames2, theme.fixed, fixed), _defineProperty(_classnames2, theme.inverse, inverse), _classnames2), className);
      return _react["default"].createElement("div", {
        "data-react-toolbox": "tabs",
        className: classNames
      }, _react["default"].createElement("div", {
        className: theme.navigationContainer
      }, _react["default"].createElement("div", {
        className: theme.navigation,
        role: "tablist",
        ref: function ref(node) {
          _this3.navigationNode = node;
        }
      }, this.renderHeaders(headers), _react["default"].createElement("span", {
        className: classNamePointer,
        style: this.state.pointer
      }))), this.renderContents(contents));
    }
  }]);

  return Tabs;
}(_react.Component);

exports.Tabs = Tabs;

_defineProperty(Tabs, "defaultProps", {
  index: 0,
  fixed: false,
  inverse: false,
  hideMode: 'unmounted',
  disableAnimatedBottomBorder: false,
  disableTextAnimation: false
});

var _default = (0, _ThemeProvider.applyTheme)('Tab', Tabs);

exports["default"] = _default;